<script setup>
import DashboardStatsAdminCard from '@/Components/Dashboard/DashboardStatsAdminCard'
import OverdueIcon from '@/icons/OverdueIcon'

import { computed } from 'vue'

const props = defineProps({
	invoices: {
		type: Array,
		default: null,
	},
})

const overdueNum = computed(() => {
	if (props.invoices === null) return 0
	return props.invoices.filter(invoice => invoice.Status === 'AUTHORISED').length
})

const overdueAmount = computed(() => {
	if (props.invoices === null) return 0
	return props.invoices.filter(invoice => invoice.Status === 'AUTHORISED').reduce((acc, invoice) => acc + invoice.AmountDue, 0)
})
</script>
<template>
	<BlockLoader class="h-64 w-full" v-if="invoices === null" />
	<DashboardStatsAdminCard
		:icon=OverdueIcon
		v-if="overdueNum"
		:data="overdueNum"
		caption="Invoices Overdue"
		linkText="Go To Invoices"
		:href="route('dashboard.invoices.index')"
	>
		<p v-if="overdueAmount" class="text-xs bg-Red text-white text-center px-2 py-1 rounded-xl mt-2">
			${{ overdueAmount.toFixed(2) }}<br /> in overdue funds
		</p>
	</DashboardStatsAdminCard>
</template>